import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LanguageInit} from '../_metronic/i18n/LanguageInit'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import AppInternetGuard from './modules/errors/components/AppInternetGuard'
const App = () => {
  // console.log = console.warn = console.error = () => {}

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LanguageInit />
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
        <AppInternetGuard />
      </I18nProvider>
    </Suspense>
  )
}

export {App}
